import React from 'react';

import PropTypes from 'prop-types';

import { LinkButton } from '@adsk/alloy-react-button';
import theme from '@adsk/alloy-react-theme';
import { OverflowTooltip } from '@adsk/alloy-react-tooltip';

const TagCell = ({ rowData, filterTags, onTagClick, isDisabled }) => (
  <OverflowTooltip
    autoTipOnEllipsis
    style={{
      zIndex: 9999,
      maxWidth: 250,
      wordBreak: 'normal',
      wordWrap: 'break-word',
    }}
    variant={OverflowTooltip.VARIANTS.LIGHT}
    triggerTarget={OverflowTooltip.TRIGGER_TARGETS.TOOLTIP}
  >
    {(rowData.tags || []).map((tag, index) => (
      <span key={index}>
        <LinkButton
          style={{
            color: isDisabled
              ? theme.colors.charcoal500
              : theme.colors.adskBlue500,
            ...((filterTags || []).includes(tag) && {
              lineHeight: '25px',
              border: `2px solid ${theme.colors.adskBlue300}`,
              borderRadius: '4px',
            }),
            '&:focus': {
              'box-shadow': 'none',
            },
          }}
          onClick={(e) => {
            e?.stopPropagation(); // Avoid table row get selected
            onTagClick(tag);
          }}
        >
          {tag}
        </LinkButton>
        {index !== rowData.tags.length - 1 && ', '}
      </span>
    ))}
  </OverflowTooltip>
);

TagCell.propTypes = {
  /**
   * row data
   */
  rowData: PropTypes.shape({
    tags: PropTypes.arrayOf(PropTypes.string),
  }),
  /**
   * current selected tags in the filter
   */
  filterTags: PropTypes.arrayOf(PropTypes.string),
  /**
   * callback when a tag is clicked
   */
  onTagClick: PropTypes.func.isRequired,
  /**
   * whether the cell is disabled
   */
  isDisabled: PropTypes.bool,
};

export default TagCell;
